// @noflow
import React from 'react'

import Notification from '@/components/elements/atoms/InPageNotification/InPageNotification'

import type { EditDailyAmountQuery_user_subscription_plan as Plan } from '../../queries/__generated__/EditDailyAmountQuery'

const LARGEST_DAILY_AMOUNT = 1200

type Props = {
  chosenPlan: Plan | null
}

const LargestPlanNotification = ({
  chosenPlan
}: Props): React.JSX.Element | null => {
  if (chosenPlan?.servingInformation.gramsPerDay !== LARGEST_DAILY_AMOUNT) {
    return null
  }

  return (
    <Notification
      text={{
        text: 'edit_daily_amount.daily_calorie_guidance.notification.text',
        namespace: 'account'
      }}
      variant="info"
    />
  )
}

export { LARGEST_DAILY_AMOUNT, LargestPlanNotification }
